// Third-party
import React from 'react';
import { connect } from 'react-redux';

// Redux
import { FormattedMessage } from 'react-intl';
import { ReduxState } from '../../../redux/modules/types';
import { selectDelegateMode } from '../../../redux/modules/auth/selectors';
import sessionStorage, { SessionStorageKey } from '../../../utils/session-storage';
import User from '@/types/user';

interface Props {
  user?: User | null;
  delegateMode: boolean;
}

class DelegateBanner extends React.Component<Props> {
  componentDidUpdate(prevProps: Props) {
    if (prevProps.user?.id !== this.props.user?.id) {
      this.show();
    }
  }

  dismiss = () => {
    sessionStorage.setItem(SessionStorageKey.DELEGATES_BANNER_DISMISS, 'true');
    this.setState({ dismissed: true });
  };

  show = () => {
    sessionStorage.setItem(SessionStorageKey.DELEGATES_BANNER_DISMISS, '');
    this.setState({ dismissed: false });
  };

  render() {
    const { user, delegateMode } = this.props;

    if (!user || !delegateMode) {
      return null;
    }

    const name = `${user.fname} ${user.lname} ${user.uid ? `(${user.uid})` : ''}`;

    return (
      <div className="delegate-banner">
        <FormattedMessage id="Delegates.WorkingAs" values={{ name }} />
      </div>
    );
  }
}

const mapStateToProps = (state: ReduxState) => ({
  user: state.auth.user,
  delegateMode: selectDelegateMode(state),
});

export default connect(mapStateToProps)(DelegateBanner);
